module.exports = __webpack_public_path__ + "img/bandperformance.1a1f975c.jpg";